module.exports = __webpack_public_path__ + "static/media/ivn_account_exists.a5d1031a.svg";